export default {
    PRINT: 1,
    WEB_BANNER: 2,
    SOCIAL: 3,
    WEBSITE_TEMPLATES: 4,
    GENERAL_MERCHANDISE: 6
}